/* PDP-Galerie: Pfeile prev/next auf dem Hauptbild (Ben, 2026-09-07) – erzeugt von _konsolidierung/pdp_button_gallery.py
   Blättert durch die AKTUELL vorhandenen .pdp-thumbs .th (zur Klickzeit abgefragt) – funktioniert nach Farb-/Metall-/Varianten-
   Wechsel, weil der Klick auf das Thumbnail-Bild die bestehende Galerie-Logik (Hauptbild + aktiver Thumbnail) auslöst. Umlaufend. */
(function(){
  function init(){
    var main=document.querySelector('.pdp-main'); if(!main||main.querySelector('.pdp-arrow')) return;
    function mk(dir,label,path){var b=document.createElement('button');b.type='button';b.className='pdp-arrow '+dir;b.setAttribute('aria-label',label);
      b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="'+path+'"/></svg>';main.appendChild(b);return b;}
    var prev=mk('prev','Vorheriges Bild','m15 6-6 6 6 6'), next=mk('next','Nächstes Bild','m9 6 6 6-6 6');
    /* nur sichtbare Thumbnails (Galerie v4 blendet nicht passende per hidden aus) */
    function thumbs(){return Array.prototype.slice.call(document.querySelectorAll('.pdp-thumbs .th:not([hidden])'));}
    function current(ths){
      for(var i=0;i<ths.length;i++) if(ths[i].classList.contains('active')) return i;
      var mi=document.getElementById('pdp-main-img')||main.querySelector('img'), src=mi?mi.getAttribute('src'):'';
      for(var j=0;j<ths.length;j++){var im=ths[j].querySelector('img'); if(im&&(im.getAttribute('data-full')===src||im.getAttribute('src')===src)) return j;}
      return 0;
    }
    function go(d){var ths=thumbs(); if(ths.length<2) return; var t=ths[(current(ths)+d+ths.length)%ths.length];
      (t.querySelector('img')||t).click(); if(t.scrollIntoView) t.scrollIntoView({block:'nearest',inline:'nearest'});}
    prev.addEventListener('click',function(e){e.preventDefault();go(-1);});
    next.addEventListener('click',function(e){e.preventDefault();go(1);});
    function vis(){var n=thumbs().length; prev.hidden=next.hidden=n<2; main.style.cursor=n<2?'':'pointer';}
    vis();
    var box=document.querySelector('.pdp-thumbs'); if(box&&window.MutationObserver) new MutationObserver(vis).observe(box,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
    main.setAttribute('tabindex','-1');
    main.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();go(-1);}else if(e.key==='ArrowRight'){e.preventDefault();go(1);}});
    /* G1b (T25): Wischen auf dem Hauptbild (Touch/Stift). CSS .pdp-main{touch-action:pan-y pinch-zoom} laesst
       senkrechtes Scrollen und Zoomen mit zwei Fingern (R2) beim Browser, waagerecht > 40 px und deutlich
       waagerechter als senkrecht blaettert. Gilt auch, wenn der Finger auf einem Pfeil startet (die
       Touch-Anpassung des Browsers zieht Beruehrungen am Rand dorthin); ein Tipp bleibt unter 40 px und ist
       weiter ein normaler Pfeil-Klick. */
    var x0=null,y0=0,gewischt=0;
    main.addEventListener('pointerdown',function(e){x0=null; if(e.pointerType==='mouse') return; x0=e.clientX;y0=e.clientY;});
    main.addEventListener('pointerup',function(e){if(x0===null) return; var dx=e.clientX-x0,dy=e.clientY-y0; x0=null;
      if(Math.abs(dx)>40&&Math.abs(dx)>1.5*Math.abs(dy)){ gewischt=Date.now(); go(dx<0?1:-1); }});
    main.addEventListener('pointercancel',function(){x0=null;});
    /* Conversion #1 (02.11.2026, Clarity: 75 % der toten Taps auf Produktseiten gehen aufs Hauptbild):
       Tipp/Klick aufs Hauptbild blaettert wie der „Weiter“-Pfeil zum naechsten Bild (umlaufend). Kein Zoom, kein Vollbild.
       Pfeile, Vorschau-Knopf und Links behalten ihr Verhalten; direkt nach einem Wischen kein zweiter Wechsel. */
    main.addEventListener('click',function(e){
      if(e.target.closest && e.target.closest('.pdp-arrow,button,a')) return;
      if(Date.now()-gewischt<450) return;
      if(thumbs().length<2) return;
      go(1);
    });
    /* G1b (T14): Bildwechsel ansagen ("Bild 2 von 5: <alt>"), erst nach der ersten Bedienung, nicht beim Laden */
    var mi=document.getElementById('pdp-main-img'), ans=document.getElementById('pdp-bild-ansage'), bedient=false, tAns=0;
    ['pointerdown','keydown'].forEach(function(t){document.addEventListener(t,function(){bedient=true;},true);});
    if(mi&&ans&&window.MutationObserver) new MutationObserver(function(){ if(!bedient) return; clearTimeout(tAns); tAns=setTimeout(function(){
      var ths=thumbs(), mid=mi.getAttribute('data-mid'), i=-1;
      for(var k=0;k<ths.length;k++){ if(ths[k].getAttribute('data-mid')===mid){ i=k; break; } }
      var txt=(i>-1&&ths.length>1?'Bild '+(i+1)+' von '+ths.length+': ':'')+(mi.getAttribute('alt')||'');
      if(ans.textContent!==txt) ans.textContent=txt; },80); }).observe(mi,{attributes:true,attributeFilter:['data-mid']});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

/* ===== Galerie v4 (Theme-Kopie 09.10.2026, G1a: T01 T02 T05 T06, N16-N18) =====
   Ersetzt die Farbgalerie v3 (Ben, 14.09./22.09.2026) und den frueheren Inline-Renderer in
   sections/product-detail.liquid. Es gibt nur noch EINEN Renderer, und der baut nichts neu:
   snippets/pdp-galerie.liquid rendert ALLE Medien als Thumbnails (jedes genau einmal) und schreibt an
   jedes Thumbnail die Klassifizierung (data-f/-l/-m = '|Index|' des Farb-/Leder-/Metallwerts aus dem
   Dateinamen, data-z = Farben aus der Variantenzuordnung, leer = neutral; data-n = Werkstatt-/Siegelfoto).
   Die Dateinamen-Regeln der v3 (Namensende "-<farbe>", Rollensuffix, "-leder", Metall-Segment, _<uuid>)
   laufen jetzt dort, einmal fuer Server und Browser.
   Neu: Farbe auch aus der Zuordnung variant.featured_media, wenn der Dateiname keine nennt.
   Hier wird nur noch je Auswahl sortiert und ein-/ausgeblendet (hidden), gleiche Regeln wie im Snippet:
     0 exaktes Variantenbild  1 Farbe + Leder/Metall passend  Rueckfall nur ohne 0/1: 2 gleiche Farbe
     anderes Leder, sonst 3 gleiche Farbe anderes Metall  4 Lederbild  5 geteilt  6 nur per Zuordnung
     einer anderen Farbe: ausgeblendet, wenn die Farbe eigene Bilder hat (0-3), sonst wie geteilt.
     Nachbesserung R2: Farbuebersicht/-skala (data-u) fuer fremde Farben wie geteilt (5) statt 6. data-zm
     ('|Farbe:Metall|') begrenzt die Zuordnung auf die Kombinationen der zugeordneten Varianten.
     Metall-Trennung (10.10.2026): data-x ('|Farbe:Metall|', vom Snippet) markiert ein Farbbild ohne Metall im Namen als
     fremd, wenn es fuer Farbe+Metall ein eigenes Metallbild gibt und das Bild einem anderen Metall zugeordnet ist (Rang 3).
   Hauptbild = 0, sonst erstes sichtbares Bild ohne data-n; sind nur Werkstatt-/Siegelfotos sichtbar,
   kommt das Titelbild (Pos. 1) nach vorn (N17). alt kommt immer mit (T03).
   Variantenbild: aus pdp-variant-json (erste 250), sonst aus #pdp-variant-id[data-media] bzw. dem
   Ereignis 'pdp:variante', das pdpAusServer mit der Medien-ID aus der Section-Antwort ausloest (T01).
   Steht die Antwort noch aus, bleibt die Galerie stehen statt auf Pos. 1 zu springen.
   Aendert ein Wechsel die sichtbare Galerie nicht (z. B. nur Groesse), bleibt das gerade gezeigte Bild stehen.
   Beim Laden wird nichts umgebaut, solange die Auswahl der vom Server gerenderten entspricht. */
(function(){
  var gal = document.querySelector('.pdp-gallery[data-galerie]'); if(!gal) return;
  var box = gal.querySelector('.pdp-thumbs'); if(!box) return;
  var form = document.getElementById('pdp-form'); if(!form) return;
  var opts = form.querySelectorAll('.opt'); if(!opts.length) return;
  function achse(n){ var v = parseInt(gal.getAttribute(n), 10); return isNaN(v) ? -1 : v; }
  var AF = achse('data-achse-farbe'), AL = achse('data-achse-leder'), AM = achse('data-achse-metall');
  var ths = Array.prototype.map.call(box.querySelectorAll('.th[data-mid]'), function(el){
    return {el:el, mid:el.getAttribute('data-mid'), pos:parseInt(el.getAttribute('data-pos'),10)||0,
            f:el.getAttribute('data-f')||'', l:el.getAttribute('data-l')||'', m:el.getAttribute('data-m')||'',
            z:el.getAttribute('data-z')||'', zm:el.getAttribute('data-zm')||'', x:el.getAttribute('data-x')||'', u:el.getAttribute('data-u') === '1',
            n:el.getAttribute('data-n') === '1'};
  });
  if(!ths.length) return;
  ths.sort(function(a,b){ return a.pos - b.pos; });   /* Produktreihenfolge */
  window.pdpGalerieV4 = true;
  var vj = [];
  try{ var je = document.getElementById('pdp-variant-json'); vj = je ? (JSON.parse(je.textContent) || []) : []; }catch(e){ vj = []; }
  var bekannt = {};   /* Auswahl -> Medien-ID aus den Ereignissen von pdpAusServer */
  /* zuletzt sichtbare Reihe (Medien-IDs); Startwert = Server-Galerie */
  var letzte = Array.prototype.filter.call(box.querySelectorAll('.th[data-mid]'), function(el){ return !el.hasAttribute('hidden'); })
    .map(function(el){ return el.getAttribute('data-mid'); }).join(',');

  function auswahl(){
    return Array.prototype.map.call(opts, function(o){ var c = o.querySelector('input[type=radio]:checked'); return c ? c.value : null; });
  }
  function index(i){
    if(i < 0 || !opts[i]) return -1;
    var rs = opts[i].querySelectorAll('input[type=radio]');
    for(var k=0;k<rs.length;k++){ if(rs[k].checked) return k; }
    return -1;
  }
  /* -> Medien-ID (String), '' = Variante ohne Bild, null = noch unbekannt (Server-Antwort steht aus) */
  function variantenMedium(sel){
    var key = sel.join('||'), i, x;
    for(i=0;i<vj.length;i++){
      x = vj[i];
      if(x && x.options && x.options.length === sel.length && x.options.every(function(v,j){ return v === sel[j]; })){
        return (x.featured_media && x.featured_media.id) ? String(x.featured_media.id) : '';
      }
    }
    if(Object.prototype.hasOwnProperty.call(bekannt, key)) return bekannt[key];
    var idEl = document.getElementById('pdp-variant-id');
    if(idEl && idEl.value && idEl.getAttribute('data-opts') === key) return idEl.getAttribute('data-media') || '';
    return null;
  }
  function hat(set, i){ return set !== '' && set.indexOf('|' + i + '|') > -1; }
  function setzeHaupt(t){
    var main = document.getElementById('pdp-main-img'); if(!main || !t) return;
    if(window.pdpHauptSetzen && window.pdpHauptSetzen(t.el)) return;   /* src + srcset + Masse + alt (G1b, T19/T20) */
    var img = t.el.querySelector('img'); if(!img) return;
    main.removeAttribute('srcset');
    var f = img.getAttribute('data-full'), a = img.getAttribute('alt') || main.getAttribute('data-alt-fallback') || '';
    if(f && main.getAttribute('src') !== f) main.setAttribute('src', f);
    if(main.getAttribute('alt') !== a) main.setAttribute('alt', a);
    main.setAttribute('data-mid', t.mid);
  }
  /* G1b (T25): zuletzt bediente Optionszeile - dort erscheint mobil die Bildvorschau */
  var zeile = null;
  function merke(e){ var z = e.target && e.target.closest ? e.target.closest('.opt, .optx') : null; if(z) zeile = z; }
  form.addEventListener('click', merke, true); form.addEventListener('keydown', merke, true);
  /* Mobil liegt das Hauptbild bei der Optionswahl oft ausserhalb des Sichtfelds: dann kleine Vorschau des neuen
     Bilds oben rechts an der bedienten Zeile (ohne Layout-Verschiebung); Antippen scrollt zum Hauptbild. */
  function vorschau(t){
    var b = form.querySelector('.pdp-vorschau'), m = gal.querySelector('.pdp-main');
    var mobil = window.matchMedia ? window.matchMedia('(max-width: 820px)').matches : false;
    var r = m ? m.getBoundingClientRect() : null, h = window.innerHeight || 0;
    var anteil = (r && r.height) ? Math.max(0, Math.min(r.bottom, h) - Math.max(r.top, 0)) / r.height : 1;
    var img = t ? t.el.querySelector('img') : null;
    if(!mobil || !img || !zeile || anteil >= 0.5 || !form.contains(zeile) || !zeile.getClientRects().length){ if(b) b.parentNode.removeChild(b); return; }
    if(!b){
      b = document.createElement('button'); b.type = 'button'; b.className = 'pdp-vorschau';
      b.setAttribute('aria-label', 'Neues Produktbild ansehen'); b.innerHTML = '<img alt="">';
      b.addEventListener('click', function(){
        var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if(m) m.scrollIntoView({behavior: ruhig ? 'auto' : 'smooth', block: 'center'});
      });
    }
    b.querySelector('img').setAttribute('src', img.getAttribute('src'));
    if(b.parentNode !== zeile) zeile.appendChild(b);
  }
  function render(ausWechsel){
    var sel = auswahl(); if(sel.indexOf(null) > -1) return;
    var vm = variantenMedium(sel); if(vm === null) return;
    var ci = index(AF), li = index(AL), mi = index(AM);
    var V = null, k1 = [], k2 = [], k3 = [], k4 = [], k5 = [], k5a = [], k6 = [], k9 = [];
    ths.forEach(function(t){
      if(vm && t.mid === vm){ V = t; return; }
      if(AF < 0){ k5.push(t); k5a.push(t); return; }   /* ohne Farbachse: alles sichtbar, Variantenbild vorn (T08) */
      var cm = t.f !== '' ? hat(t.f, ci) : hat(t.z, ci);
      if(cm && t.f === '' && t.zm !== '' && t.zm.indexOf('|' + ci + ':' + mi + '|') < 0) cm = false;   /* R2: anderes Metall */
      var lok = AL < 0 || t.l === '' || hat(t.l, li);
      var mok = AM < 0 || (t.m === '' ? !hat(t.x, ci + ':' + mi) : hat(t.m, mi));   /* Metall-Trennung 10.10.: data-x = fremd fuer Farbe:Metall */
      if(cm){ if(lok && mok) k1.push(t); else if(mok) k2.push(t); else k3.push(t); }
      else if(t.f === '' && lok && mok){
        if(t.l !== '') k4.push(t);
        else if(t.z !== '' && !t.u){ k6.push(t); k5a.push(t); }
        else { k5.push(t); k5a.push(t); }
      }
      else k9.push(t);
    });
    var eigen = !!(V || k1.length || k2.length || k3.length);
    if(!eigen){ k5 = k5a; k6 = []; }
    var fb = (V || k1.length) ? null : (k2.length ? k2 : (k3.length ? k3 : null));
    var sicht = (V ? [V] : []).concat(k1, fb || [], k4, k5);
    var aus = (fb === k2 ? [] : k2).concat(fb === k3 ? [] : k3, k6, k9);
    if(!sicht.length){ sicht = k9; aus = (fb === k2 ? [] : k2).concat(fb === k3 ? [] : k3, k6); }
    /* Nur Werkstatt-/Siegelfotos sichtbar: Titelbild (Pos. 1) nach vorn holen (N17) */
    if(!V && !sicht.some(function(t){ return !t.n; }) && ths[0] && !ths[0].n && sicht.indexOf(ths[0]) < 0){
      sicht.unshift(ths[0]); aus = aus.filter(function(t){ return t !== ths[0]; });
    }
    var haupt = V || sicht.filter(function(t){ return !t.n; })[0] || sicht[0] || null;
    /* Galerie unveraendert (z. B. nur Groesse gewechselt): gewaehltes Bild nicht zuruecksetzen */
    var key = sicht.map(function(t){ return t.mid; }).join(','), mainEl = document.getElementById('pdp-main-img');
    var aktuell = mainEl ? mainEl.getAttribute('data-mid') : null;
    if(key === letzte && aktuell){ var bleibt = sicht.filter(function(t){ return t.mid === aktuell; })[0]; if(bleibt) haupt = bleibt; }
    letzte = key;
    var reihe = sicht.concat(aus), i, gleich = box.children.length === reihe.length;
    for(i=0; gleich && i<reihe.length; i++){ if(box.children[i] !== reihe[i].el) gleich = false; }
    if(!gleich) reihe.forEach(function(t){ box.appendChild(t.el); });
    reihe.forEach(function(t, j){
      if(j < sicht.length) t.el.removeAttribute('hidden'); else t.el.setAttribute('hidden', '');
      t.el.classList.toggle('active', t === haupt);
      if(t === haupt) t.el.setAttribute('aria-current', 'true'); else t.el.removeAttribute('aria-current');   /* T14 */
    });
    var vorher = aktuell;
    if(haupt) setzeHaupt(haupt);
    if(ausWechsel && haupt && haupt.mid !== vorher){
      if(!gleich) box.scrollLeft = 0;   /* mobil: neue Reihe beginnt sichtbar am Anfang der Thumb-Leiste */
      vorschau(haupt);
    }
  }
  document.addEventListener('pdp:variante', function(e){
    var d = e && e.detail; if(d && typeof d.opts === 'string') bekannt[d.opts] = String(d.media || '');
    render(true);
  });
  /* Beim Laden nur umbauen, wenn die Auswahl nicht mehr der vom Server gerenderten entspricht
     (z. B. vom Browser wiederhergestellte Radios) - sonst bleibt das Server-Bild unangetastet. */
  if(auswahl().join('||') !== (gal.getAttribute('data-opts') || '')) render();
})();

/* ===== Zwei-Reihen-Farbwahl fuer gefaltete Farbachsen (Ben/Birte, 22.09.2026) =====
   Shopify erlaubt hart 3 Produktoptionen. Ein Bicolor-Halsband braucht aber vier Achsen:
   Hauptfarbe, Zweitfarbe, Groesse, Beschlag. Haupt- und Zweitfarbe liegen deshalb in EINEM
   Optionswert, getrennt durch " · " ("Hellbraun · Cognac") - dieselbe Faltung, die
   Ben am 16.09.2026 schon fuer Laenge/Breite benutzt hat.
   Hier wird diese eine Achse als ZWEI Reihen runder Farbfelder dargestellt. Die echte gefaltete
   Achse bleibt als .opt-Container mit echten Radios im DOM und wird nur ausgeblendet -
   pdpSelectedOptions(), pdpOvids(), der v2-Guard und beide Galerien sehen unveraendert 3 Achsen.

   BEWUSST als .optx (nicht .opt): jeder zusaetzliche .opt-Container in #pdp-form wuerde als
   weitere Achse gezaehlt und der Guard wuerde bei jedem Klick fehlschlagen.
   Ein Klick setzt das passende echte Radio und feuert ein ECHTES change-Event -
   'radio.checked = true' allein feuert KEINES, dann blieben Preis, verstecktes name=id,
   Kauf-Button und die Galerie auf der alten Variante stehen.
   Ohne JS bleibt die gefaltete Zeile sichtbar und voll bedienbar - harmloser Rueckfall. */
(function(){
  var SEP = ' · ';
  /* Fettleder-Palette, spiegelt snippets/fettleder-hex.liquid.
     'hellbraun' fehlt dort und ist hier aus den Produktfotos gemessen (#c07324). */
  var HEX = {schwarz:'#1A1A1A', dunkelbraun:'#4c391c', braun:'#4c391c', hellbraun:'#c07324',
             cognac:'#d27e1c', grau:'#9e9a93', oliv:'#6a7a37', tannengruen:'#1b5124',
             blau:'#0E5661', marine:'#31307e', marineblau:'#31307e', lila:'#68107e',
             pink:'#cc2ab2', rot:'#b02f1e', orange:'#e06b21', tuerkis:'#0E5661'};
  function slug(s){ return String(s||'').toLowerCase()
      .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss')
      .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function hex(n){ return HEX[slug(n)] || ''; }
  function esc(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }

  function init(){
    var form = document.getElementById('pdp-form'); if(!form) return;
    /* gefaltete Farbachse finden: Label enthaelt "farbe", Werte enthalten den Trenner */
    var opt = null;
    Array.prototype.forEach.call(form.querySelectorAll('.opt'), function(o){
      if(opt) return;
      var lab = o.querySelector('.lab'), r = o.querySelector('input[type=radio]');
      if(lab && /farbe/i.test(lab.textContent) && r && r.value.indexOf(SEP) > -1) opt = o;
    });
    if(!opt || opt.__paarReady) return;
    var radios = Array.prototype.slice.call(opt.querySelectorAll('input[type=radio]'));
    /* jeder Wert muss exakt in zwei nichtleere Teile zerfallen - sonst Finger weg */
    for(var i=0;i<radios.length;i++){
      var p = radios[i].value.split(SEP);
      if(p.length !== 2 || !p[0].trim() || !p[1].trim()) return;
    }
    opt.__paarReady = 1;

    var lblH = 'Hauptfarbe', lblZ = 'Farbe';
    var labEl = opt.querySelector('.lab');
    var name = labEl ? labEl.textContent.split(':')[0].trim() : '';
    var teile = name.split(' & ');
    if(teile.length === 2){ lblH = teile[0].trim(); lblZ = teile[1].trim(); }

    var haupt = [], zweit = [], paare = {};
    radios.forEach(function(r){
      var p = r.value.split(SEP), h = p[0].trim(), z = p[1].trim();
      if(haupt.indexOf(h) < 0) haupt.push(h);
      if(zweit.indexOf(z) < 0) zweit.push(z);
      paare[h + '|' + z] = r;
    });

    var cur = radios.filter(function(r){ return r.checked; })[0] || radios[0];
    var curH = cur.value.split(SEP)[0].trim(), curZ = cur.value.split(SEP)[1].trim();

    function reihe(cls, label, werte, attr){
      var html = '<div class="lab">' + esc(label) + ': <span class="optx-sel"></span></div><div class="opt-row">';
      werte.forEach(function(v){
        var c = hex(v);
        html += c
          ? '<button type="button" class="opt-swatch optx-pill" role="radio" aria-checked="false" title="'+esc(v)+'" aria-label="'+esc(v)+'" style="background:'+c+'" '+attr+'="'+esc(v)+'"></button>'
          : '<button type="button" class="opt-pill optx-pill" role="radio" aria-checked="false" '+attr+'="'+esc(v)+'">'+esc(v)+'</button>';
      });
      var d = document.createElement('div');
      d.className = 'optx ' + cls; d.setAttribute('role','radiogroup');
      d.setAttribute('aria-label', label); d.innerHTML = html + '</div>';
      return d;
    }
    var rowH = reihe('optx--h', lblH, haupt, 'data-h');
    var rowZ = reihe('optx--z', lblZ, zweit, 'data-z');
    opt.parentNode.insertBefore(rowH, opt);
    opt.parentNode.insertBefore(rowZ, opt);
    opt.classList.add('opt--folded');
    form.classList.add('pdp-paar-ready');

    function mark(row, attr, val){
      Array.prototype.forEach.call(row.querySelectorAll('.optx-pill'), function(p){
        var on = p.getAttribute(attr) === val;
        p.classList.toggle('active', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var s = row.querySelector('.optx-sel'); if(s) s.textContent = val;
    }
    /* Zweitfarben, die es zur gewaehlten Hauptfarbe nicht gibt, ausgrauen und unklickbar machen */
    function zweitPruefen(){
      Array.prototype.forEach.call(rowZ.querySelectorAll('.optx-pill'), function(p){
        var gibt = !!paare[curH + '|' + p.getAttribute('data-z')];
        p.classList.toggle('nicht-vorraetig', !gibt);
        p.disabled = !gibt;
      });
    }
    function apply(){
      var r = paare[curH + '|' + curZ];
      if(!r) return false;
      if(!r.checked){ r.checked = true; r.dispatchEvent(new Event('change', {bubbles:true})); }
      mark(rowH, 'data-h', curH); mark(rowZ, 'data-z', curZ); zweitPruefen();
      return true;
    }
    function bind(row, attr, setter){
      row.addEventListener('click', function(e){
        var p = e.target && e.target.closest ? e.target.closest('.optx-pill') : null;
        if(!p || p.disabled || !row.contains(p)) return;
        var neu = p.getAttribute(attr); if(neu === null) return;
        var vorherH = curH, vorherZ = curZ;
        setter(neu);
        if(!apply()){
          /* Kombination gibt es nicht: erste verfuegbare Zweitfarbe der neuen Hauptfarbe nehmen */
          var fallback = zweit.filter(function(z){ return paare[curH + '|' + z]; })[0];
          if(fallback){ curZ = fallback; if(apply()) return; }
          curH = vorherH; curZ = vorherZ; apply();
        }
      });
    }
    bind(rowH, 'data-h', function(v){ curH = v; });
    bind(rowZ, 'data-z', function(v){ curZ = v; });
    /* G1b: aendert die Auto-Auswahl (T09) die gefaltete Farbachse, ziehen beide Reihen nach */
    radios.forEach(function(r){ r.addEventListener('change', function(){
      if(!r.checked) return; var p = r.value.split(SEP); if(p.length !== 2) return;
      curH = p[0].trim(); curZ = p[1].trim(); mark(rowH, 'data-h', curH); mark(rowZ, 'data-z', curZ); zweitPruefen();
    }); });
    apply();
  }

  var css = document.createElement('style');
  css.textContent =
    '.pdp-paar-ready .opt--folded{display:none}' +
    '.optx{margin-top:26px}' +
    '.optx .lab{font-weight:700;font-size:13.5px;margin-bottom:12px}' +
    '.optx .lab span{color:var(--ink-3)}' +
    '.optx .opt-row{display:flex;flex-wrap:wrap;gap:10px}' +
    '.optx .opt-swatch{padding:0;line-height:0;border:3px solid #fff;-webkit-appearance:none;appearance:none}' +
    '.optx .opt-pill{font-family:inherit;font-size:13px;line-height:1.6;margin:0;-webkit-appearance:none;appearance:none}' +
    '.optx .optx-pill.nicht-vorraetig{opacity:.28;cursor:not-allowed}';
  (document.head || document.documentElement).appendChild(css);

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ===== Verfuegbarkeit je Auswahl (Ben/Birte, 22.09.2026) =====
   Das Liquid graut einen Optionswert nur aus, wenn er ueber ALLE Kombinationen hinweg
   ausverkauft ist. Ist z.B. nur Tuerkis/45 ohne Material (Pure Basic, 22.09.2026), blieb die
   45 schwarz und der Kunde merkte es erst am gesperrten Kauf-Button. Hier wird nach jeder
   Auswahl je Achse geprueft, ob die daraus entstehende Kombination verkaeuflich waere, und
   der Wert sonst ausgegraut.
   BEWUSST konservativ: fehlt eine Kombination im Seiten-JSON, bleibt sie unangetastet.
   Liquid liefert `product.variants` nur bis 250 Eintraege - bei groesseren Produkten
   (Braidy bicolor: 476) wuerde ein Fehlen sonst faelschlich als "ausverkauft" gelesen.
   Die gefaltete Achse (.opt--folded) wird uebersprungen, sie ist ohnehin ausgeblendet.
   G1b (N14, 09.10.2026): Ist die Liste vollstaendig (#pdp-form data-varianten-voll="1"), wird eine fehlende
   Kombination stufenweise wie bei Shopify bewertet: Der Wert ist waehlbar, wenn es mit den Werten der Achsen
   DAVOR eine verfuegbare Variante gibt (die Auto-Auswahl passt die Achsen danach an), sonst ausgegraut.
   Die erste Achse wird so nur ausgegraut, wenn der Wert ganz ausverkauft ist. Ueber 250 Varianten bleibt es
   beim konservativen Weg, die Markierungen kommen dort aus der Section-Antwort (product-detail.liquid). */
(function(){
  var TRENNER = '\u0000';
  function pruefen(){
    var form = document.getElementById('pdp-form'); if(!form) return;
    var el = document.getElementById('pdp-variant-json'); if(!el) return;
    var vj; try{ vj = JSON.parse(el.textContent); }catch(e){ return; }
    if(!vj || !vj.length) return;
    var opts = Array.prototype.slice.call(form.querySelectorAll('.opt'));
    var sel = opts.map(function(o){
      var c = o.querySelector('input[type=radio]:checked'); return c ? c.value : null;
    });
    if(sel.indexOf(null) > -1) return;
    var idx = {}, voll = form.getAttribute('data-varianten-voll') === '1';
    vj.forEach(function(v){ if(v && v.options) idx[v.options.join(TRENNER)] = v; });
    opts.forEach(function(o, i){
      if(o.classList.contains('opt--folded')) return;
      Array.prototype.forEach.call(o.querySelectorAll('input[type=radio]'), function(r){
        var probe = sel.slice(); probe[i] = r.value;
        var v = idx[probe.join(TRENNER)];
        var lab = r.closest ? r.closest('label') : null;
        if(!lab) return;
        if(v){ lab.classList.toggle('nicht-vorraetig', v.available === false); return; }
        if(!voll) return;                      /* unbekannt -> nicht anfassen */
        var geht = vj.some(function(x){
          if(!x || !x.options || !x.available || x.options[i] !== r.value) return false;
          for(var j = 0; j < i; j++){ if(x.options[j] !== sel[j]) return false; }
          return true;
        });
        lab.classList.toggle('nicht-vorraetig', !geht);
      });
    });
  }
  function binden(){
    var form = document.getElementById('pdp-form'); if(!form) return;
    Array.prototype.forEach.call(form.querySelectorAll('input[type=radio]'), function(r){
      r.addEventListener('change', function(){ setTimeout(pruefen, 0); });
    });
    setTimeout(pruefen, 0);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', binden); else binden();
})();